import PropTypes from 'prop-types';
import { useBarIndicatorsColors } from '@/composables/useBarIndicatorsColors';
import { Box } from '@mui/material';
import { formatNumber } from '@/helpers/format/formatNumber.js';
import { BREAKPOINTS } from '@/constants/IndicatorBarBreakpoints';

const DeviceBinStateField = ({ record, className }) => {
    const binStateNumber = formatNumber(record.binState ?? 0, 0);
    const barColors = useBarIndicatorsColors(binStateNumber, BREAKPOINTS, true, true);

    return (
        <Box
            className={className}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
            }}
        >
            <Box sx={{ display: 'flex', gap: '2px', flexDirection: 'column' }}>
                {barColors.map((color, i) => (
                    <Box
                        key={i}
                        sx={{
                            width: '18px',
                            height: '3px',
                            borderRadius: '2px',
                            backgroundColor: color,
                        }}
                    />
                ))}
            </Box>

            <Box
                sx={{
                    fontSize: '14px',
                    fontWeight: '600',
                }}
            >
                {binStateNumber}%
            </Box>
        </Box>
    );
};

DeviceBinStateField.propTypes = {
    record: PropTypes.shape({
        binState: PropTypes.number,
    }),
    className: PropTypes.string,
};

export default DeviceBinStateField;
